import './style.css';
import { HeaderCardapio } from '../../../Components/HeaderCardapio';
import { Link, useParams, useLocation } from 'react-router-dom';
import { useGlobal } from '../../../GlobalContext';
import { resolveClientColor } from '../../../Utills/colors';
import Loading from '../../../Components/Loading';
import FloatingOrderButton from '../../../Components/FloatingOrderButton';
import FloatingServiceButton from '../../../Components/FloatingServiceButton';

import imgCafeDaManha from '../../../Assets/tipoRefeicao/cafe-da-manha.jpg';
import imgAlmoco from '../../../Assets/tipoRefeicao/almoco.jpg';
import imgJantar from '../../../Assets/tipoRefeicao/jantar.jpg';
import imgBebidas from '../../../Assets/tipoRefeicao/bebidas.jpg';
import imgBar from '../../../Assets/tipoRefeicao/bar.jpg';
import imgSnacks from '../../../Assets/tipoRefeicao/snacks.jpg';
import imgSobremesa from '../../../Assets/tipoRefeicao/sobremesa.jpg';
import imgOutros from '../../../Assets/tipoRefeicao/outros.jpg';

const imageUrls = [
  imgCafeDaManha,
  imgAlmoco,
  imgJantar,
  imgBebidas,
  imgBar,
  imgSnacks,
  imgSobremesa,
  imgOutros,
];

const TipoRefeicao = () => {
  const { menu, loading } = useGlobal();
  const { cliente_id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const apartamento = queryParams.get('x');
  const cliente_url = queryParams.get('id_cliente');
  const session_control = queryParams.get('session_control');

  if (loading || !menu) {
    return (
      <div className="loading-container">
        <Loading />
      </div>
    );
  }

  const cor2 = resolveClientColor();
  const cor_letra = localStorage.getItem('cliente_cor_letra');
  const tiposRefeicaoOrdenados = [...(menu.tipo_refeicao || [])].sort(
    (a, b) => Number(a.ordem) - Number(b.ordem),
  );

  return (
    <div>
      <HeaderCardapio />

      <div className="MainGrid">
        <div className="firstColumn">
          <div
            className="box"
            style={{
              margin: '10px auto',
              border: 'none',
              background: 'var(--background-main)',
            }}
          >
            <p style={{ textAlign: 'center' }}>Escolha um item</p>

            <div className="div_tipo_grid">
              <div
                className="container__btn_facilities div__btn__flex"
                style={{ marginTop: '20px' }}
              >
                {tiposRefeicaoOrdenados.map((tipo, index) => (
                  <div key={tipo.id}>
                    <Link
                      to={`/${cliente_id}/cardapio/${tipo.id}/${location.search}`}
                      style={{
                        backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),url(${
                          imageUrls[index % imageUrls.length]
                        })`,
                      }}
                      className="btn_facilities btn_facilities_tipo_refeicao"
                    >
                      {tipo.nome}
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <FloatingOrderButton themeColor={cor2} textColor={cor_letra} />
      <FloatingServiceButton
        themeColor={cor2}
        textColor={cor_letra}
        onCallWaiter={() => {
          console.log('Garçom chamado');
          // aqui você chama sua API
        }}
        onAskBill={() => {
          console.log('Conta solicitada');
          // aqui você chama sua API
        }}
      />
    </div>
  );
};

export default TipoRefeicao;
